import { cn as e } from "../shared/utils.js";
import { CheckboxCheckIcon as t, checkboxIndicatorVariants as n, checkboxRootVariants as r } from "./primitive/index.js";
import { jsx as i } from "react/jsx-runtime";
//#region src/checkbox/static-checkbox.tsx
var a = ({ checked: a, className: o, size: s = "md" }) => /* @__PURE__ */ i("div", {
	"aria-hidden": !0,
	className: e(r({
		checked: a,
		interactive: !1,
		size: s
	}), o),
	"data-slot": "static-checkbox",
	"data-testid": "static-checkbox",
	children: a ? /* @__PURE__ */ i("span", {
		className: n({ size: s }),
		"data-checked": "",
		children: /* @__PURE__ */ i(t, {})
	}) : null
});
//#endregion
export { a as StaticCheckbox };
